module.exports = __webpack_public_path__ + "static/media/studio-3.1d5451ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/studio-3.jpg
// module id = 5857
// module chunks = 0